<script lang="ts">let { size = "20" } = $props();
</script>

<svg height={size} style="fill: currentColor" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg">
	<g>
		<path
			d="M12.498 8.01c1.672 0 3.03-1.35 3.03-3.007S14.17 2 12.498 2s-3.03 1.346-3.03 3.003c0 1.656 1.364 3.008 3.03 3.008"
		/>
		<path
			d="M19.953 16.952a2.4 2.4 0 0 0-.673.1l-4.292-3.292h2.295a1.44 1.44 0 0 0 1.082-.49c.27-.294.388-.689.337-1.072a6.16 6.16 0 0 0-2.878-4.46 4.32 4.32 0 0 1-3.327 1.557c-1.335 0-2.541-.6-3.327-1.557a6.14 6.14 0 0 0-2.878 4.46c-.05.389.068.784.337 1.073.275.311.668.489 1.083.489h2.294l-4.291 3.292a2.4 2.4 0 0 0-.674-.1A2.533 2.533 0 0 0 2.5 19.476C2.5 20.866 3.639 22 5.047 22c1.403 0 2.547-1.134 2.547-2.524 0-.523-.163-1.001-.432-1.401l4.488-3.442v2.474a2.51 2.51 0 0 0-1.694 2.369c0 1.39 1.139 2.524 2.547 2.524 1.402 0 2.547-1.134 2.547-2.524a2.51 2.51 0 0 0-1.7-2.369v-2.474l4.488 3.442c-.27.4-.432.884-.432 1.4 0 1.39 1.145 2.525 2.547 2.525 1.408 0 2.547-1.134 2.547-2.524a2.534 2.534 0 0 0-2.547-2.524"
		/>
	</g>
</svg>
